// extracted by mini-css-extract-plugin
export default {"name":"InfoSign_name__ZM5KE"};